module.exports = __webpack_public_path__ + "img/python.c43b5763.webp";